export default __webpack_public_path__ + "static/media/b4.904f991a.png";